export enum CalculatorsTheme {
  WITH_TABLE = 'WITH_TABLE',
  WITH_BOXES = 'WITH_BOXES',
  MULTI_SLIDER = 'MULTI_SLIDER',
  SINGLE_SLIDER = 'SINGLE_SLIDER'
}
